import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "backdrop",
    "siteName",
    "baseDate"
  ]

  open(event) {
    const td = event.target.closest("td")
    if (!td || td.classList.contains("site-col")) return

    const tr = td.closest("tr")

    const siteName = tr.dataset.siteName
    const date = td.dataset.date

    if (!siteName || !date) {
      console.warn("Missing data:", { siteName, date })
      return
    }

    this.siteNameTarget.textContent = siteName
    this.baseDateTarget.textContent = this.formatDate(date)

    this.backdropTarget.classList.add("show")
  }


  close() {
    this.backdropTarget.classList.remove("show")
  }

  formatDate(dateStr) {
    const d = new Date(dateStr)
    return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`
  }
}
